/**
 * Spanish translations of backend response messages, keyed by the exact
 * English text the backend sends (CustomError / success messages).
 * Single source of truth for FE and BE localization — the frontend loads
 * this as the i18next 'backend' namespace; unknown messages pass through.
 */
export const backendMessagesEs: Record<string, string> = {
  '(#133010) Account not registered': '(#133010) Cuenta no registrada',
  '2FA has been successfully disabled for your account.':
    'La 2FA se ha deshabilitado correctamente para su cuenta.',
  '2FA has been successfully enabled for your account.':
    'La 2FA se ha habilitado correctamente para su cuenta.',
  '2FA is already enabled for this user':
    '2FA ya está habilitada para este usuario',
  '2FA is not enabled for this user':
    '2FA no está habilitada para este usuario',
  '2FA not configured correctly': '2FA no está configurada correctamente',
  '2FA setup initiated. Please verify to complete setup.':
    'Configuración de 2FA iniciada. Verifique para completar la configuración.',
  '2FA setup not found. Please initiate 2FA setup first.':
    'No se encontró la configuración de 2FA. Primero inicie la configuración de 2FA.',
  '2FA status retrieved successfully.': 'Estado de 2FA obtenido correctamente.',
  '2FA token required': 'Se requiere el token de 2FA',
  'A positive "take" value (limit) is required for pagination.':
    'Se requiere un valor "take" (límite) positivo para la paginación.',
  'A valid business must be present in the request token to attach credit line':
    'Debe haber un negocio válido en el token de la solicitud para vincular la línea de crédito',
  'AI results retrieved successfully':
    'Resultados de IA obtenidos correctamente',
  'API key added successfully': 'Clave de API agregada correctamente',
  'API key deleted successfully': 'Clave de API eliminada correctamente',
  'API key has been revoked': 'La clave de API ha sido revocada',
  'API key not found': 'Clave de API no encontrada',
  'API key revoked successfully': 'Clave de API revocada correctamente',
  'API keys retrieved successfully': 'Claves de API obtenidas correctamente',
  'Access Token not found': 'Token de acceso no encontrado',
  'Access Token not valid': 'Token de acceso no válido',
  'Access denied': 'Acceso denegado',
  'Access denied. VPC only.': 'Acceso denegado. Solo VPC.',
  'Account already exists': 'La cuenta ya existe',
  'Analytics data is temporarily unavailable, please try again shortly':
    'Los datos de analítica no están disponibles temporalmente, inténtelo de nuevo en breve',
  'Active API key set successfully':
    'Clave de API activa establecida correctamente',
  'Active bots retrieved successfully': 'Bots activos obtenidos correctamente',
  'Active call already exists for this client':
    'Ya existe una llamada activa para este cliente',
  'An update is already in progress for this function. Please wait a moment and try again.':
    'Ya hay una actualización en curso para esta función. Espere un momento y vuelva a intentarlo.',
  'App not found!': '¡Aplicación no encontrada!',
  'At least one of subject, description, or profile picture file is required':
    'Se requiere al menos uno de: asunto, descripción o archivo de foto de perfil',
  'At least one of tags or attributes must be provided':
    'Se debe proporcionar al menos uno de: etiquetas o atributos',
  'Copilot chats are tied to a signed-in user and are not available to API keys.':
    'Los chats de Copilot están vinculados a un usuario con sesión iniciada y no están disponibles para las claves de API.',
  'Invalid session id': 'Id de sesión no válido',
  'This chat has newer messages on another device. Reload to catch up before saving.':
    'Este chat tiene mensajes más recientes en otro dispositivo. Vuelve a cargar para ponerte al día antes de guardar.',
  'audio file is required': 'Se requiere el archivo de audio',
  Transcribed: 'Transcrito',
  'Transcription failed': 'La transcripción falló',
  'Authenticated email missing': 'Falta el correo electrónico autenticado',
  'Authentication required.': 'Se requiere autenticación.',
  'Authorization header is required.':
    'Se requiere el encabezado Authorization.',
  "Authorization header must be formatted as 'Bearer [token]'.":
    "El encabezado Authorization debe tener el formato 'Bearer [token]'.",
  'Authorization successful.': 'Autorización exitosa.',
  'Balance added successfully': 'Saldo agregado correctamente',
  'before and beforeId must each be a single value':
    'before y beforeId deben ser cada uno un único valor',
  'before must be a valid ISO timestamp':
    'before debe ser una marca de tiempo ISO válida',
  'beforeId must be sent together with before':
    'beforeId debe enviarse junto con before',
  'Bill ID is required.': 'Se requiere el ID de la factura.',
  'Bill deleted successfully.': 'Factura eliminada correctamente.',
  'Bill fetched successfully.': 'Factura obtenida correctamente.',
  'Bill not found.': 'Factura no encontrada.',
  'Bill updated successfully.': 'Factura actualizada correctamente.',
  'Billing data generated successfully.':
    'Datos de facturación generados correctamente.',
  'Bills fetched successfully.': 'Facturas obtenidas correctamente.',
  'Blocked clients fetched successfully':
    'Clientes bloqueados obtenidos correctamente',
  'Books mapping fetched.': 'Mapeo de Books obtenido.',
  'Books mapping is not enabled for this business.':
    'El mapeo de Books no está habilitado para este negocio.',
  'Books mapping updated.': 'Mapeo de Books actualizado.',
  'Bot results retrieved successfully':
    'Resultados del bot obtenidos correctamente',
  'Business Account ID or FB Access Token is missing!':
    '¡Falta el Business Account ID o el FB Access Token!',
  'Business has no Meta access token configured':
    'El negocio no tiene un token de acceso de Meta configurado',
  'Business has no WhatsApp phone number configured':
    'El negocio no tiene un número de teléfono de WhatsApp configurado',
  'Business ID is required': 'Se requiere el ID del negocio',
  'Business WhatsApp credentials not configured':
    'Las credenciales de WhatsApp del negocio no están configuradas',
  'Business deleted successfully!': '¡Negocio eliminado correctamente!',
  'Business details are missing. Please add business details first!':
    'Faltan los datos del negocio. ¡Primero agregue los datos del negocio!',
  'Business details are missing. Please add business details first.':
    'Faltan los datos del negocio. Primero agregue los datos del negocio.',
  'Business details are missing. Please complete WhatsApp setup first.':
    'Faltan los datos del negocio. Primero complete la configuración de WhatsApp.',
  'Business details are missing. So please add first business details!':
    'Faltan los datos del negocio. ¡Primero agregue los datos del negocio!',
  'Business does not have a Facebook Access Token.':
    'El negocio no tiene un token de acceso de Facebook.',
  'Business does not have a Facebook App ID. So please add Facebook App ID in WhatsApp API Setup!':
    'El negocio no tiene un Facebook App ID. ¡Agregue el Facebook App ID en la configuración de la API de WhatsApp!',
  'Business has no orgId': 'El negocio no tiene orgId',
  'Business name updated successfully!':
    '¡Nombre del negocio actualizado correctamente!',
  'Business not found': 'Negocio no encontrado',
  'Business not found in your organization.':
    'Negocio no encontrado en su organización.',
  'Business not found or does not belong to this organization':
    'Negocio no encontrado o no pertenece a esta organización',
  'Business not found or does not belong to this partner.':
    'Negocio no encontrado o no pertenece a este socio.',
  'Business not found!': '¡Negocio no encontrado!',
  'Business not found.': 'Negocio no encontrado.',
  'Business phone number is not configured correctly':
    'El número de teléfono del negocio no está configurado correctamente',
  'Business setup correctly not found':
    'No se encontró una configuración correcta del negocio',
  'Business setup is incomplete':
    'La configuración del negocio está incompleta',
  'Business setup is incomplete. Missing fbAccessToken or businessAccountId.':
    'La configuración del negocio está incompleta. Falta fbAccessToken o businessAccountId.',
  'Business updated successfully': 'Negocio actualizado correctamente',
  'Call accepted successfully!': '¡Llamada aceptada correctamente!',
  'Call initiated successfully!': '¡Llamada iniciada correctamente!',
  'Call messages retrieved successfully':
    'Mensajes de llamada obtenidos correctamente',
  'Call pre-accepted successfully!': '¡Llamada preaceptada correctamente!',
  'Call rejected successfully!': '¡Llamada rechazada correctamente!',
  'Call terminated successfully': 'Llamada finalizada correctamente',
  'Call terminated successfully!': '¡Llamada finalizada correctamente!',
  'Campaign not found': 'Campaña no encontrada',
  'Cannot Verify Webhook Token!':
    '¡No se puede verificar el token del webhook!',
  'Cannot delete $LATEST version': 'No se puede eliminar la versión $LATEST',
  'Cannot delete a business with completed setup. Only incomplete setups can be deleted.':
    'No se puede eliminar un negocio con la configuración completada. Solo se pueden eliminar configuraciones incompletas.',
  'Cannot delete the last business. At least one business is required.':
    'No se puede eliminar el último negocio. Se requiere al menos un negocio.',
  'Cannot revoke — at least one OWNER must retain access to each business.':
    'No se puede revocar — al menos un OWNER debe conservar acceso a cada negocio.',
  'Cannot use "after" and "before" cursors simultaneously.':
    'No se pueden usar los cursores "after" y "before" simultáneamente.',
  'Chat completion successful': 'Chat completion exitoso',
  'Chatbot assigned to client successfully':
    'Bot asignado al cliente correctamente',
  'Chatbot assignment removed from client':
    'Asignación del bot eliminada del cliente',
  'Chatbot config retrieved': 'Configuración del bot obtenida',
  'Chatbot conversation triggered successfully':
    'Conversación del bot activada correctamente',
  'Chatbot created successfully': 'Bot creado correctamente',
  'Chatbot deleted successfully': 'Bot eliminado correctamente',
  'Chatbot exported successfully': 'Bot exportado correctamente',
  'Chatbot imported successfully': 'Bot importado correctamente',
  'Chatbot not found': 'Bot no encontrado',
  'Chatbot nudges fetched successfully':
    'Recordatorios del bot obtenidos correctamente',
  'Chatbot response generated successfully':
    'Respuesta del bot generada correctamente',
  'Chatbot retrieved successfully': 'Bot obtenido correctamente',
  'Chatbot updated successfully': 'Bot actualizado correctamente',
  'Chatbots retrieved successfully': 'Bots obtenidos correctamente',
  'ClickHouse analytics is not enabled':
    'La analítica de ClickHouse no está habilitada',
  'ClickHouse is not available': 'ClickHouse no está disponible',
  'ClickHouse is unavailable; cannot generate bills.':
    'ClickHouse no está disponible; no se pueden generar facturas.',
  'Client chat status updated successfully':
    'Estado del chat del cliente actualizado correctamente',
  'Client has not opted in': 'El cliente no ha dado su consentimiento',
  'Client is blocked': 'El cliente está bloqueado',
  'Client not found': 'Cliente no encontrado',
  'Clients created/updated successfully':
    'Clientes creados/actualizados correctamente',
  'Code executed': 'Código ejecutado',
  'Code executed successfully': 'Código ejecutado correctamente',
  'Code saved successfully': 'Código guardado correctamente',
  'Coexistence is not enabled for this business!':
    '¡La coexistencia no está habilitada para este negocio!',
  'Compressed payload too large': 'El payload comprimido es demasiado grande',
  'Contact not found': 'Contacto no encontrado',
  'Contact updated successfully.': 'Contacto actualizado correctamente.',
  'Copilot response received': 'Respuesta de Copilot recibida',
  'Cost analytics retrieved successfully':
    'Analítica de costos obtenida correctamente',
  'Could not find whatsapp_business_messaging scope with target_ids in granular_scopes':
    'No se encontró el scope whatsapp_business_messaging con target_ids en granular_scopes',
  'Could not prepare storage for upload. Please try again.':
    'No se pudo preparar el almacenamiento para la carga. Vuelva a intentarlo.',
  'Could not resolve a contact from the given identifiers':
    'No se pudo resolver un contacto a partir de los identificadores proporcionados',
  'Credit line attached successfully':
    'Línea de crédito vinculada correctamente',
  'Currency conversion failed.': 'Falló la conversión de moneda.',
  'Daily engagement analytics retrieved successfully':
    'Analítica de interacción diaria obtenida correctamente',
  'Debug context retrieved': 'Contexto de depuración obtenido',
  'Edit lock status': 'Estado del bloqueo de edición',
  'Either phoneNumberId or businessId, clientWaNumber, and either text or messages are required':
    'Se requiere phoneNumberId o businessId, clientWaNumber, y text o messages',
  'Either text, media, or a button/list reply must be provided':
    'Se debe proporcionar texto, medios o una respuesta de botón/lista',
  'Email is required': 'Se requiere el correo electrónico',
  'Email is required!': '¡Se requiere el correo electrónico!',
  'Email verified. Your account is ready — please log in.':
    'Correo electrónico verificado. Su cuenta está lista — inicie sesión.',
  'Embed session created.': 'Sesión de incrustación creada.',
  'Employee not found': 'Empleado no encontrado',
  'Employee not found!': '¡Empleado no encontrado!',
  'Employee record not found': 'Registro de empleado no encontrado',
  'Error 500': 'Error 500',
  'Error during message search': 'Error durante la búsqueda de mensajes',
  'Error fetching business profile details!':
    '¡Error al obtener los detalles del perfil del negocio!',
  'Error in JWT Token!': '¡Error en el token JWT!',
  'Error in SSO authorization.': 'Error en la autorización SSO.',
  'Error in authorization.': 'Error en la autorización.',
  'Error in embedded signup': 'Error en el registro integrado',
  'Error in fetching single flow': 'Error al obtener el flujo',
  'Error updating business profile details!':
    '¡Error al actualizar los detalles del perfil del negocio!',
  'Error while marking message as read':
    'Error al marcar el mensaje como leído',
  'Estimate details fetched successfully.':
    'Detalles de la cotización obtenidos correctamente.',
  'Estimate marked as accepted.': 'Cotización marcada como aceptada.',
  'Estimate not found.': 'Cotización no encontrada.',
  'Execution role is not configured. Please contact support.':
    'El rol de ejecución no está configurado. Contacte a soporte.',
  Forbidden: 'Prohibido',
  'Facebook Access Token not found':
    'Token de acceso de Facebook no encontrado',
  'Failed to accept call': 'No se pudo aceptar la llamada',
  'Failed to attach credit line for this business':
    'No se pudo vincular la línea de crédito para este negocio',
  'Failed to create Karix account for credit line':
    'No se pudo crear la cuenta de Karix para la línea de crédito',
  'Failed to create flow': 'No se pudo crear el flujo',
  'Failed to create template': 'No se pudo crear la plantilla',
  'Failed to create template with library. Please contact customer support':
    'No se pudo crear la plantilla con la biblioteca. Contacte a soporte al cliente',
  'Failed to create template. Please contact customer support':
    'No se pudo crear la plantilla. Contacte a soporte al cliente',
  'Failed to create versioned function.':
    'No se pudo crear la función versionada.',
  'Failed to delete hash templates':
    'No se pudieron eliminar las plantillas hash',
  'Failed to delete template': 'No se pudo eliminar la plantilla',
  'Failed to delete the flow': 'No se pudo eliminar el flujo',
  'Failed to delete version': 'No se pudo eliminar la versión',
  'Failed to deprecate the flow': 'No se pudo marcar el flujo como obsoleto',
  'Failed to fetch JsonFlow': 'No se pudo obtener el JsonFlow',
  'Failed to fetch analytics': 'No se pudo obtener la analítica',
  'Failed to fetch call settings':
    'No se pudo obtener la configuración de llamadas',
  'Failed to fetch conversation analytics':
    'No se pudo obtener la analítica de conversaciones',
  'Failed to fetch data localization region from Meta.':
    'No se pudo obtener la región de localización de datos desde Meta.',
  'Failed to fetch data localization region.':
    'No se pudo obtener la región de localización de datos.',
  'Failed to fetch form responses due to a server error':
    'No se pudieron obtener las respuestas del formulario debido a un error del servidor',
  'Failed to fetch meta acount health status!':
    '¡No se pudo obtener el estado de salud de la cuenta de Meta!',
  'Failed to fetch pricing analytics':
    'No se pudo obtener la analítica de precios',
  'Failed to fetch template analytics':
    'No se pudo obtener la analítica de plantillas',
  'Failed to fetch whatsapp commerce settings':
    'No se pudo obtener la configuración de comercio de WhatsApp',
  'Failed to generate Karix token for credit line':
    'No se pudo generar el token de Karix para la línea de crédito',
  'Failed to generate system prompt. Please try again.':
    'No se pudo generar el prompt del sistema. Vuelva a intentarlo.',
  'Failed to get response from AI. Please try again.':
    'No se pudo obtener respuesta de la IA. Vuelva a intentarlo.',
  'Failed to initiate call': 'No se pudo iniciar la llamada',
  'Failed to pre-accept call': 'No se pudo preaceptar la llamada',
  'Failed to preview the flow': 'No se pudo previsualizar el flujo',
  'Failed to process templates': 'No se pudieron procesar las plantillas',
  'Failed to publish the flow': 'No se pudo publicar el flujo',
  'Failed to register phone number!':
    '¡No se pudo registrar el número de teléfono!',
  'Failed to reject call': 'No se pudo rechazar la llamada',
  'Failed to request coexistence sync!':
    '¡No se pudo solicitar la sincronización de coexistencia!',
  'Failed to retrieve template message analytics':
    'No se pudo obtener la analítica de mensajes de plantilla',
  'Failed to send typing indicator!':
    '¡No se pudo enviar el indicador de escritura!',
  'Failed to subscribe to webhooks!': '¡No se pudo suscribir a los webhooks!',
  'Failed to terminate call': 'No se pudo finalizar la llamada',
  'Failed to update call settings':
    'No se pudo actualizar la configuración de llamadas',
  'Failed to update data localization region on Meta.':
    'No se pudo actualizar la región de localización de datos en Meta.',
  'Failed to update data localization region.':
    'No se pudo actualizar la región de localización de datos.',
  'Failed to update jwt token': 'No se pudo actualizar el token jwt',
  'Failed to update template': 'No se pudo actualizar la plantilla',
  'Failed to update the flow': 'No se pudo actualizar el flujo',
  'Failed to update whatsapp commerce settings':
    'No se pudo actualizar la configuración de comercio de WhatsApp',
  'Failed to upload through Resumable API':
    'No se pudo subir mediante la Resumable API',
  'Fallback config deleted successfully':
    'Configuración de respaldo eliminada correctamente',
  'Fallback config not found': 'Configuración de respaldo no encontrada',
  'Fallback config saved successfully':
    'Configuración de respaldo guardada correctamente',
  'Fallback configs fetched successfully':
    'Configuraciones de respaldo obtenidas correctamente',
  'Fetch flows error': 'Error al obtener los flujos',
  'Fetched data localization region.':
    'Región de localización de datos obtenida.',
  'Fetched function details': 'Detalles de la función obtenidos',
  'Fetched versions': 'Versiones obtenidas',
  'Field name too long.': 'Nombre de campo demasiado largo.',
  'Field value too long.': 'Valor de campo demasiado largo.',
  'File is required': 'Se requiere el archivo',
  'File not accessible': 'Archivo no accesible',
  'File not found in request body!':
    '¡Archivo no encontrado en el cuerpo de la solicitud!',
  'File too large. Please upload a smaller file.':
    'Archivo demasiado grande. Suba un archivo más pequeño.',
  'File type and file name are required!':
    '¡Se requieren el tipo y el nombre del archivo!',
  'Filename is too long. Maximum 255 characters allowed.':
    'El nombre del archivo es demasiado largo. Se permiten máximo 255 caracteres.',
  'Flow executed': 'Flujo ejecutado',
  'Function bundle not available':
    'El paquete de la función no está disponible',
  'Function executed successfully': 'Función ejecutada correctamente',
  'GST status fetched successfully.': 'Estado de GST obtenido correctamente.',
  'GSTIN updated successfully.': 'GSTIN actualizado correctamente.',
  'Graph API Error': 'Error de la Graph API',
  'Group deletion requested': 'Eliminación del grupo solicitada',
  'Group info retrieved': 'Información del grupo obtenida',
  'Group settings update requested':
    'Actualización de la configuración del grupo solicitada',
  'HTTP request executed': 'Solicitud HTTP ejecutada',
  Hello: 'Hola',
  'Hello there': 'Hola',
  'Hello!': '¡Hola!',
  Hi: 'Hola',
  'Hi there': 'Hola',
  'Incorrect or expired code. If it keeps failing, please start the sign-up again to get a new code.':
    'Código incorrecto o vencido. Si sigue fallando, inicie el registro nuevamente para obtener un código nuevo.',
  'Invalid 2FA token': 'Token de 2FA no válido',
  'Invalid 2FA token. Please provide a valid token to disable 2FA.':
    'Token de 2FA no válido. Proporcione un token válido para deshabilitar la 2FA.',
  'Invalid 2FA token. Please try again.':
    'Token de 2FA no válido. Vuelva a intentarlo.',
  'Invalid Google token': 'Token de Google no válido',
  'Invalid HTTP request options': 'Opciones de solicitud HTTP no válidas',
  'Invalid Pipecat secret': 'Secreto de Pipecat no válido',
  'Invalid Web Verification Token': 'Token de verificación web no válido',
  'Invalid amount. Must be greater than 0.':
    'Monto no válido. Debe ser mayor que 0.',
  'Invalid business ID': 'ID de negocio no válido',
  'Invalid business context': 'Contexto de negocio no válido',
  'Invalid business id.': 'ID de negocio no válido.',
  'Invalid config ID': 'ID de configuración no válido',
  'Invalid cursor format': 'Formato de cursor no válido',
  'Invalid date format. Expected YYYY-MM-DD format (e.g., "2025-11-01").':
    'Formato de fecha no válido. Se espera el formato YYYY-MM-DD (p. ej., "2025-11-01").',
  'Invalid date format. Use YYYY-MM-DD':
    'Formato de fecha no válido. Use YYYY-MM-DD',
  'Invalid destination phone number': 'Número de teléfono de destino no válido',
  'Invalid email or password': 'Correo electrónico o contraseña no válidos',
  'Invalid email or password2.': 'Correo electrónico o contraseña no válidos2.',
  'Invalid employee ID': 'ID de empleado no válido',
  'Invalid filename. Please use a safe filename without special characters.':
    'Nombre de archivo no válido. Use un nombre de archivo seguro sin caracteres especiales.',
  'Invalid message type': 'Tipo de mensaje no válido',
  'Invalid or missing orgId parameter.':
    'Parámetro orgId no válido o faltante.',
  'Invalid org ID': 'ID de organización no válido',
  'Invalid request data': 'Datos de solicitud no válidos',
  'Invalid response data': 'Datos de respuesta no válidos',
  'Invalid voice bot secret': 'Secreto del bot de voz no válido',
  'Invalid webhook signature': 'Firma de webhook no válida',
  'Invite link reset': 'Enlace de invitación restablecido',
  'Invite link retrieved': 'Enlace de invitación obtenido',
  'Invite valid': 'Invitación válida',
  'Invoice URL fetched successfully.':
    'URL de la factura obtenida correctamente.',
  'Invoice is not available for this bill yet.':
    'La factura aún no está disponible para este período.',
  'Iteration complete': 'Iteración completada',
  'Join requests approved': 'Solicitudes de unión aprobadas',
  'Join requests rejected': 'Solicitudes de unión rechazadas',
  'Join requests retrieved': 'Solicitudes de unión obtenidas',
  'Journey not found': 'Journey no encontrado',
  'Just one': 'Solo uno',
  'KARIX_ACCESS_TOKEN is not configured':
    'KARIX_ACCESS_TOKEN no está configurado',
  'Legacy API key(s) revoked successfully':
    'Clave(s) de API heredada(s) revocada(s) correctamente',
  'Link successfully created.': 'Enlace creado correctamente.',
  'Links successfully created.': 'Enlaces creados correctamente.',
  'Links successfully retrieved.': 'Enlaces obtenidos correctamente.',
  'Live chatbots config updated successfully':
    'Configuración de bots en vivo actualizada correctamente',
  'LiveKit agent name is not configured':
    'El nombre del agente de LiveKit no está configurado',
  'LiveKit credentials are not configured':
    'Las credenciales de LiveKit no están configuradas',
  'Logged out successfully': 'Sesión cerrada correctamente',
  'Message ID is required!': '¡Se requiere el ID del mensaje!',
  'Message marked as read!': '¡Mensaje marcado como leído!',
  'Message not found': 'Mensaje no encontrado',
  'Message search is currently unavailable. Please try again later.':
    'La búsqueda de mensajes no está disponible en este momento. Vuelva a intentarlo más tarde.',
  'Message search timed out. Please refine your query and try again.':
    'La búsqueda de mensajes agotó el tiempo de espera. Refine su consulta y vuelva a intentarlo.',
  'Messages sent successfully': 'Mensajes enviados correctamente',
  'Meta agent not found': 'Agente de Meta no encontrado',
  'Meta AI is handling this chat. Only Meta can hand a conversation to a human — it does that on its own when it decides one is needed. To stop the agent everywhere, unpublish it.':
    'Meta AI está gestionando este chat. Solo Meta puede pasar una conversación a una persona, y lo hace por su cuenta cuando decide que hace falta. Para detener al agente en todos los chats, despublícalo.',
  'Missing X-Pipecat-Secret header': 'Falta el encabezado X-Pipecat-Secret',
  'Missing X-Voice-Bot-Secret header': 'Falta el encabezado X-Voice-Bot-Secret',
  'Missing authorization header': 'Falta el encabezado de autorización',
  'Missing edit session id': 'Falta el id de la sesión de edición',
  'Models retrieved successfully': 'Modelos obtenidos correctamente',
  'Monitoring data fetched successfully':
    'Datos de monitoreo obtenidos correctamente',
  'No Meta AI agent is configured on this number yet':
    'Este número aún no tiene un agente de Meta AI configurado',
  'No Meta agent is active': 'Ningún agente de Meta está activo',
  'No SIP configuration found': 'No se encontró configuración SIP',
  'No active LLM API key found. Please configure an API key first.':
    'No se encontró una clave de API de LLM activa. Primero configure una clave de API.',
  'No active call found': 'No se encontró una llamada activa',
  'No active employee found to assign chat!':
    '¡No se encontró un empleado activo para asignar el chat!',
  'No billing configured for this organization.':
    'No hay facturación configurada para esta organización.',
  'No billing data for this period.':
    'No hay datos de facturación para este período.',
  'No business context — pass businessId or use a business-scoped JWT.':
    'No hay contexto de negocio — pase businessId o use un JWT con alcance de negocio.',
  'No businesses found for this org':
    'No se encontraron negocios para esta organización',
  'No organizations found for this partner':
    'No se encontraron organizaciones para este socio',
  'No call found for this callId':
    'No se encontró una llamada para este callId',
  'No call message found to update (early failure)':
    'No se encontró un mensaje de llamada para actualizar (falla temprana)',
  'No chatbot available for this business':
    'No hay ningún bot disponible para este negocio',
  'No chatbotId provided and no active voice bot configured':
    'No se proporcionó chatbotId y no hay un bot de voz activo configurado',
  'No hash templates found to delete':
    'No se encontraron plantillas hash para eliminar',
  'No org found': 'No se encontró la organización',
  'No organization is associated with this account.':
    'No hay ninguna organización asociada a esta cuenta.',
  'No responseData found in responseMiddleware':
    'No se encontró responseData en responseMiddleware',
  'No retainer invoice found for this estimate. Make sure the estimate has been accepted in Zoho first.':
    'No se encontró una factura de anticipo para esta cotización. Asegúrese de que la cotización haya sido aceptada primero en Zoho.',
  'No templates found to process': 'No se encontraron plantillas para procesar',
  'No valid message content': 'No hay contenido de mensaje válido',
  'No voice bot configured': 'No hay un bot de voz configurado',
  'Not Enabled.': 'No habilitado.',
  'Not found.': 'No encontrado.',
  'Nudge scheduled successfully': 'Recordatorio programado correctamente',
  'OAuth client successfully created.': 'Cliente OAuth creado correctamente.',
  'One or more chatbots do not belong to this organization':
    'Uno o más bots no pertenecen a esta organización',
  'Only an OWNER can manage business access.':
    'Solo un OWNER puede administrar el acceso al negocio.',
  'Only an OWNER can restore a deleted employee.':
    'Solo un OWNER puede restaurar un empleado eliminado.',
  'Org ID or business id not found in JWT payload!':
    '¡No se encontró el ID de la organización o el id del negocio en el payload del JWT!',
  'Org context missing in request':
    'Falta el contexto de la organización en la solicitud',
  'Org not found': 'Organización no encontrada',
  'Org pricing updated successfully.':
    'Precios de la organización actualizados correctamente.',
  'Org-level functions retrieved successfully':
    'Funciones a nivel de organización obtenidas correctamente',
  'Org-wide account status is not available for this session.':
    'El estado de la cuenta de toda la organización no está disponible para esta sesión.',
  'Organization not found or does not belong to this partner.':
    'Organización no encontrada o no pertenece a este socio.',
  'Organization not found.': 'Organización no encontrada.',
  'Outbound call initiated': 'Llamada saliente iniciada',
  'PIPECAT_SECRET not configured': 'PIPECAT_SECRET no está configurado',
  'Participant removal requested': 'Eliminación de participante solicitada',
  'Partner admin added successfully.':
    'Administrador del socio agregado correctamente.',
  'Partner admin not found.': 'Administrador del socio no encontrado.',
  'Partner admin removed successfully.':
    'Administrador del socio eliminado correctamente.',
  'Partner admins fetched successfully.':
    'Administradores del socio obtenidos correctamente.',
  'Partner businesses fetched successfully.':
    'Negocios del socio obtenidos correctamente.',
  'Partner context fetched successfully.':
    'Contexto del socio obtenido correctamente.',
  'Partner context not found.': 'Contexto del socio no encontrado.',
  'Partner created successfully.': 'Socio creado correctamente.',
  'Partner not found.': 'Socio no encontrado.',
  'Partner orgs fetched successfully.':
    'Organizaciones del socio obtenidas correctamente.',
  'Partner updated successfully.': 'Socio actualizado correctamente.',
  'Partners fetched successfully.': 'Socios obtenidos correctamente.',
  'Password updated successfully!': '¡Contraseña actualizada correctamente!',
  'Patch result reported': 'Resultado del parche informado',
  'Path Does Not Exist': 'La ruta no existe',
  'Payload must be a non-empty array of client updates':
    'El payload debe ser un arreglo no vacío de actualizaciones de clientes',
  'Phone Number ID or FB Access Token is missing!':
    '¡Falta el Phone Number ID o el FB Access Token!',
  'Phone number ID or access token is missing on the business profile.':
    'Falta el ID del número de teléfono o el token de acceso en el perfil del negocio.',
  'Phone number ID or access token not found':
    'ID del número de teléfono o token de acceso no encontrado',
  'Phone number id or fb access token is missing!':
    '¡Falta el id del número de teléfono o el token de acceso de FB!',
  'Pick any\\n\\n1. Pizza\\n2. Pasta':
    'Elija una opción\\n\\n1. Pizza\\n2. Pasta',
  'Please setup account first': 'Primero configure la cuenta',
  'Policy Bazar lead dispatched to LiveKit':
    'Lead de Policy Bazar enviado a LiveKit',
  'Presigned URL generated': 'URL prefirmada generada',
  'Presigned download URL generated': 'URL de descarga prefirmada generada',
  'Presigned upload URL generated': 'URL de carga prefirmada generada',
  'Query executed': 'Consulta ejecutada',
  'Query exported to S3': 'Consulta exportada a S3',
  'Quick Replies added successfully':
    'Respuestas rápidas agregadas correctamente',
  'Re-engagement message': 'Mensaje de reactivación',
  'Real one': 'Uno real',
  'Redirect link not found.': 'Enlace de redirección no encontrado.',
  'Request Failed with Internal Server Error':
    'La solicitud falló con Internal Server Error',
  'Retainer invoice activated.': 'Factura de anticipo activada.',
  'rollout.enabled is required — agent settings have not been initialized yet':
    'rollout.enabled es obligatorio: la configuración del agente aún no se ha inicializado',
  'SIP call accepted': 'Llamada SIP aceptada',
  'SIP call initiated': 'Llamada SIP iniciada',
  'SIP call rejected': 'Llamada SIP rechazada',
  'SIP call terminated': 'Llamada SIP finalizada',
  'SIP call terminated successfully': 'Llamada SIP finalizada correctamente',
  'SIP configuration removed': 'Configuración SIP eliminada',
  'SIP configured successfully': 'SIP configurado correctamente',
  'SIP is not configured. Run setup first.':
    'SIP no está configurado. Ejecute primero la configuración.',
  'SIP trunk not found on LiveKit. Re-run SIP setup (Settings → SIP Calling) to reconnect the trunk.':
    'No se encontró el trunk SIP en LiveKit. Vuelva a ejecutar la configuración SIP (Configuración → Llamadas SIP) para reconectar el trunk.',
  'SMS channel is not yet available': 'El canal de SMS aún no está disponible',
  'Search query only contains unsupported characters':
    'La consulta de búsqueda solo contiene caracteres no admitidos',
  'Send queue temporarily unavailable, retry after a few seconds':
    'La cola de envío no está disponible temporalmente, reintente en unos segundos',
  'Session cleared successfully': 'Sesión borrada correctamente',
  'Session has been logged out': 'La sesión ha sido cerrada',
  'Session info fetched': 'Información de la sesión obtenida',
  'Session logged out successfully': 'Sesión cerrada correctamente',
  'Session not found': 'Sesión no encontrada',
  'Sessions retrieved successfully': 'Sesiones obtenidas correctamente',
  'Settings updated': 'Configuración actualizada',
  'Setup your Facebook account first!':
    '¡Configure primero su cuenta de Facebook!',
  'Short URL collision occured. Try again or increase length and try again.':
    'Ocurrió una colisión de URL corta. Intente de nuevo o aumente la longitud y vuelva a intentarlo.',
  'Short URL collision occurred. Please try again with a longer hash length.':
    'Ocurrió una colisión de URL corta. Vuelva a intentarlo con una longitud de hash mayor.',
  'Some employees do not exist!': '¡Algunos empleados no existen!',
  'Source and fallback template cannot be the same':
    'La plantilla de origen y la plantilla de respaldo no pueden ser la misma',
  'Stored attribute configuration could not be read':
    'No se pudo leer la configuración de atributos almacenada',
  'Successfully Fetched Attributes': 'Atributos obtenidos correctamente',
  'Successfully added or updated webhook URL':
    'URL del webhook agregada o actualizada correctamente',
  'Successfully added webhook': 'Webhook agregado correctamente',
  'Successfully created business api-key!':
    '¡Clave de API del negocio creada correctamente!',
  'Successfully deleted clients': 'Clientes eliminados correctamente',
  'Successfully deleted scheduled!': '¡Programación eliminada correctamente!',
  'Successfully deleted session!': '¡Sesión eliminada correctamente!',
  'Successfully deleted webhook': 'Webhook eliminado correctamente',
  'Successfully deleted webhook URL': 'URL del webhook eliminada correctamente',
  'Successfully fetched all businesses.':
    'Todos los negocios obtenidos correctamente.',
  'Successfully fetched all employees.':
    'Todos los empleados obtenidos correctamente.',
  'Successfully fetched all orgs.':
    'Todas las organizaciones obtenidas correctamente.',
  'Successfully fetched analytics!': '¡Analítica obtenida correctamente!',
  'Successfully fetched call settings!':
    '¡Configuración de llamadas obtenida correctamente!',
  'Successfully fetched form responses':
    'Respuestas del formulario obtenidas correctamente',
  'Successfully fetched pricing analytics!':
    '¡Analítica de precios obtenida correctamente!',
  'Successfully generated CSV file for Cars24 delivery report':
    'Archivo CSV del informe de entregas de Cars24 generado correctamente',
  'Successfully logged in!': '¡Sesión iniciada correctamente!',
  'Successfully previewed the flow!': '¡Flujo previsualizado correctamente!',
  'Successfully queued messages': 'Mensajes puestos en cola correctamente',
  'Successfully retrieved campaign Stats.':
    'Estadísticas de la campaña obtenidas correctamente.',
  'Successfully retrieved campaign list':
    'Lista de campañas obtenida correctamente',
  'Successfully retrieved client attributes':
    'Atributos del cliente obtenidos correctamente',
  'Successfully retrieved client details':
    'Detalles del cliente obtenidos correctamente',
  'Successfully retrieved client list':
    'Lista de clientes obtenida correctamente',
  'Successfully retrieved group list': 'Lista de grupos obtenida correctamente',
  'Successfully retrieved message': 'Mensaje obtenido correctamente',
  'Successfully retrieved messages': 'Mensajes obtenidos correctamente',
  'Successfully scheduled messages!': '¡Mensajes programados correctamente!',
  'Successfully send read status!': '¡Estado de lectura enviado correctamente!',
  'Successfully start heltarbot flow!':
    '¡Flujo de heltarbot iniciado correctamente!',
  'Successfully update jwt token': 'Token jwt actualizado correctamente',
  'Successfully updated call settings!':
    '¡Configuración de llamadas actualizada correctamente!',
  'Successfully updated employee.': 'Empleado actualizado correctamente.',
  'Successfully updated org.': 'Organización actualizada correctamente.',
  'Successfully updated the flow!': '¡Flujo actualizado correctamente!',
  'Support email config fetched successfully.':
    'Configuración del correo de soporte obtenida correctamente.',
  'Support email config updated successfully.':
    'Configuración del correo de soporte actualizada correctamente.',
  'Sure!': '¡Claro!',
  'System prompt generated successfully':
    'Prompt del sistema generado correctamente',
  'Target business is in a different organisation.':
    'El negocio de destino está en una organización diferente.',
  'Target business not found.': 'Negocio de destino no encontrado.',
  'Template analytics retrieved successfully from ClickHouse':
    'Analítica de plantillas obtenida correctamente desde ClickHouse',
  'Template category updates fetched successfully':
    'Actualizaciones de categoría de plantillas obtenidas correctamente',
  'Template cost analytics retrieved successfully':
    'Analítica de costos por plantilla obtenida correctamente',
  'Template details retrieved successfully from ClickHouse':
    'Detalles de la plantilla obtenidos correctamente desde ClickHouse',
  'Template message analytics retrieved successfully':
    'Analítica de mensajes de plantilla obtenida correctamente',
  'Testing custom error': 'Probando error personalizado',
  "The 'OWNER' role must have 'permissionManagement' enabled.":
    "El rol 'OWNER' debe tener 'permissionManagement' habilitado.",
  'The GSTIN has an unrecognized state code.':
    'El GSTIN tiene un código de estado no reconocido.',
  'This API is not accessible with an API key.':
    'Esta API no es accesible con una clave de API.',
  'This account has been deleted. Please contact your administrator.':
    'Esta cuenta ha sido eliminada. Contacte a su administrador.',
  'This action requires a logged-in session, not an API key.':
    'Esta acción requiere una sesión iniciada, no una clave de API.',
  'This email address is already linked to another contact':
    'Esta dirección de correo electrónico ya está vinculada a otro contacto',
  'This embed link has expired or was already used. Reopen it from your CRM.':
    'Este enlace incrustado ha expirado o ya fue utilizado. Vuelva a abrirlo desde su CRM.',
  'Password is required to activate your account.':
    'Se requiere una contraseña para activar tu cuenta.',
  'This invite is invalid or has expired.':
    'Esta invitación no es válida o ha expirado.',
  'Timed out while waiting for function update to finish':
    'Se agotó el tiempo de espera de la actualización de la función',
  'Token and new password are required!':
    '¡Se requieren el token y la nueva contraseña!',
  'Token invalid or expired!': '¡Token no válido o expirado!',
  'Token not provided': 'Token no proporcionado',
  'Token successfully created.': 'Token creado correctamente.',
  'Too many fields.': 'Demasiados campos.',
  'Too many files. Please upload fewer files.':
    'Demasiados archivos. Suba menos archivos.',
  'Too many parts in multipart data.':
    'Demasiadas partes en los datos multipart.',
  'Transaction history retrieved successfully':
    'Historial de transacciones obtenido correctamente',
  'Transcript saved to call message':
    'Transcripción guardada en el mensaje de la llamada',
  'Unable to dispatch Policy Bazar lead to LiveKit':
    'No se pudo enviar el lead de Policy Bazar a LiveKit',
  'Unexpected file field.': 'Campo de archivo inesperado.',
  'Update Template is not supported. Please make new template.':
    'No se admite actualizar la plantilla. Cree una plantilla nueva.',
  'Updated widget allowed origins':
    'Orígenes permitidos del widget actualizados',
  'Upload failed': 'La carga falló',
  Uploaded: 'Subido',
  'User ID and token are required': 'Se requieren el ID de usuario y el token',
  'User ID is required': 'Se requiere el ID de usuario',
  'User not found': 'Usuario no encontrado',
  'VOICE_BOT_SECRET not configured': 'VOICE_BOT_SECRET no está configurado',
  'Valid businessId is required.': 'Se requiere un businessId válido.',
  'Valid employee ID is required.': 'Se requiere un ID de empleado válido.',
  'Valid org ID is required.': 'Se requiere un ID de organización válido.',
  'Valid orgId is required.': 'Se requiere un orgId válido.',
  'Valid partner ID is required.': 'Se requiere un ID de socio válido.',
  'Valid version number is required': 'Se requiere un número de versión válido',
  'Voice bot test room ready': 'Sala de prueba del bot de voz lista',
  'Voice call fetched': 'Llamada de voz obtenida',
  'Voice calls listed': 'Llamadas de voz listadas',
  'Wallet information retrieved successfully':
    'Información de la billetera obtenida correctamente',
  'We could not create this account. It may already exist — try logging in.':
    'No pudimos crear esta cuenta. Es posible que ya exista — intente iniciar sesión.',
  'Webhook processed': 'Webhook procesado',
  'Welcome!': '¡Bienvenido!',
  'What is your name?': '¿Cuál es su nombre?',
  'WhatsApp notification sent successfully':
    'Notificación de WhatsApp enviada correctamente',
  'Whatsapp api signUp again to run this operation':
    'Vuelva a registrarse en la API de WhatsApp para ejecutar esta operación',
  'You are not authorized to access this resource':
    'No está autorizado para acceder a este recurso',
  'You can only fetch your own employee record.':
    'Solo puede consultar su propio registro de empleado.',
  'You can only grant access to businesses you can access.':
    'Solo puede otorgar acceso a negocios a los que usted tiene acceso.',
  'You cannot create tags. You can directly update the tags options':
    'No puede crear etiquetas. Puede actualizar directamente las opciones de etiquetas',
  'You do not have access to this business. Contact your account owner.':
    'No tiene acceso a este negocio. Contacte al propietario de su cuenta.',
  'You do not have partner dashboard access.':
    'No tiene acceso al panel de socios.',
  'You do not have permission to log out other users.':
    'No tiene permiso para cerrar la sesión de otros usuarios.',
  'Your account has no business access. Please contact your account owner.':
    'Su cuenta no tiene acceso a ningún negocio. Contacte al propietario de su cuenta.',
  'Your account is ready. You can now log in.':
    'Su cuenta está lista. Ya puede iniciar sesión.',
  'Your admin access is read-only. This action is not permitted.':
    'Su acceso de administrador es de solo lectura. Esta acción no está permitida.',
  'Zoho customers fetched successfully.':
    'Clientes de Zoho obtenidos correctamente.',
  'Zoho estimate fetched successfully.':
    'Cotización de Zoho obtenida correctamente.',
  'Zoho estimate not found.': 'Cotización de Zoho no encontrada.',
  'Zoho estimates fetched successfully.':
    'Cotizaciones de Zoho obtenidas correctamente.',
  'attribute parameter is missing in the request.':
    'Falta el parámetro attribute en la solicitud.',
  'businessId is required and must be a number.':
    'businessId es requerido y debe ser un número.',
  'businessId, clientWaNumber, and callUuid are required':
    'Se requieren businessId, clientWaNumber y callUuid',
  'businessIds must be an array.': 'businessIds debe ser un arreglo.',
  'callId and either phoneNumberId or businessId are required':
    'Se requieren callId y phoneNumberId o businessId',
  'callId is required': 'Se requiere callId',
  'chatbotId and phoneNumberId or businessId are required':
    'Se requieren chatbotId y phoneNumberId o businessId',
  'chatbotId is required': 'Se requiere chatbotId',
  'clientWaNumber and businessId are required.':
    'Se requieren clientWaNumber y businessId.',
  'clientWaNumber and phoneNumberId are required.':
    'Se requieren clientWaNumber y phoneNumberId.',
  'clientWaNumber is required': 'Se requiere clientWaNumber',
  'clientWaNumbers parameter is missing in the request.':
    'Falta el parámetro clientWaNumbers en la solicitud.',
  'codeZipBase64 payload is empty': 'El payload codeZipBase64 está vacío',
  'contactId is required': 'Se requiere contactId',
  'employeeId is required': 'Se requiere employeeId',
  'endDate must not be before startDate.':
    'endDate no debe ser anterior a startDate.',
  'expirationDays (1-30) is required when action=pin':
    'Se requiere expirationDays (1-30) cuando action=pin',
  'flowDefinition is required for flow chatbots':
    'Se requiere flowDefinition para los bots de flujo',
  'function not found for this org':
    'Función no encontrada para esta organización',
  'hasAccess must be a boolean.': 'hasAccess debe ser un booleano.',
  'invocation failed': 'La invocación falló',
  'media.url must be a Heltar-hosted upload URL':
    'media.url debe ser una URL de carga alojada en Heltar',
  'name, chatbotId, and either phoneNumberId or businessId are required':
    'Se requieren name, chatbotId y phoneNumberId o businessId',
  'oldattribute and newattribute in case of tags should be same.':
    'oldattribute y newattribute deben ser iguales en el caso de las etiquetas.',
  'orgId not found in JWT': 'orgId no encontrado en el JWT',
  'registrationNo and mobileNumber are required':
    'Se requieren registrationNo y mobileNumber',
  'registrationNumber and mobile are required':
    'Se requieren registrationNumber y mobile',
  'roomName is required': 'Se requiere roomName',
  'since must be an epoch timestamp':
    'since debe ser una marca de tiempo epoch',
  'startDate and endDate are required': 'Se requieren startDate y endDate',
  'startDate and endDate must be valid dates.':
    'startDate y endDate deben ser fechas válidas.',
  'startDate and endDate query params are required (YYYY-MM-DD)':
    'Se requieren los parámetros de consulta startDate y endDate (YYYY-MM-DD)',
  'startDate must be before endDate': 'startDate debe ser anterior a endDate',
  'tags attribute canot be deleted.': 'El atributo tags no se puede eliminar.',
  'templateName and date are required': 'Se requieren templateName y date',
  'wamid query parameter is required':
    'Se requiere el parámetro de consulta wamid',
  'zohoEstimateId is required': 'Se requiere zohoEstimateId',
  'zohoEstimateId is required.': 'Se requiere zohoEstimateId.',
  'Failed to deploy code. Please try again.':
    'No se pudo desplegar el código. Inténtalo de nuevo.',
  'Failed to download the code bundle. Please try again.':
    'No se pudo descargar el paquete de código. Inténtalo de nuevo.',
  'The deployment did not complete. Please try again.':
    'El despliegue no se completó. Inténtalo de nuevo.',
  'The function could not be created. Please check your configuration or try again.':
    'No se pudo crear la función. Revisa tu configuración o inténtalo de nuevo.',
};
